export const myPageMaps = {
  index: {
    title: '마이페이지',
    path: '/my-page',
    display: true,
  },
  info: {
    title: '내 정보',
    path: '/my-page/info',
    display: true,
  },
  coupon: {
    title: '나의 쿠폰',
    path: '/my-page/coupon',
    display: true,
  },

  settlement: {
    title: '월별 정산',
    path: '/my-page/settlement',
    display: true,
  },
  'credit-card': {
    title: '결제 수단',
    path: '/my-page/credit-card',
    display: true,
  },
  plan: {
    title: '나의 플랜',
    path: '/my-page/plan',
    display: true,
  },
  credit: {
    title: '나의 쿠폰',
    path: '/my-page/credit',
    display: true,
  },
};
